import { useRef, useState } from "react";

const pickMime = () => {
  const options = ["audio/webm;codecs=opus", "audio/webm", "audio/mp4", "audio/ogg"];
  return options.find((m) => window.MediaRecorder?.isTypeSupported?.(m)) || "";
};

export function useRecorder() {
  const [recording, setRecording] = useState(false);
  const [seconds, setSeconds] = useState(0);
  const rec = useRef(null);
  const timer = useRef(null);
  const chunks = useRef([]);

  const start = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    const mime = pickMime();
    const mr = new MediaRecorder(stream, mime ? { mimeType: mime } : undefined);
    chunks.current = [];
    mr.ondataavailable = (e) => e.data.size && chunks.current.push(e.data);
    mr.start();
    rec.current = mr;
    setSeconds(0);
    setRecording(true);
    timer.current = setInterval(() => setSeconds((s) => s + 1), 1000);
  };

  const finish = (keep) =>
    new Promise((resolve) => {
      const mr = rec.current;
      clearInterval(timer.current);
      setRecording(false);
      if (!mr) return resolve(null);
      mr.onstop = () => {
        mr.stream.getTracks().forEach((t) => t.stop());
        const type = (mr.mimeType || "audio/webm").split(";")[0];
        resolve(keep ? new Blob(chunks.current, { type }) : null);
      };
      mr.stop();
      rec.current = null;
    });

  return { recording, seconds, start, stop: () => finish(true), cancel: () => finish(false) };
}
